import React from 'react';
import PropTypes from 'prop-types';

const ProductSwatch = ({
  swatches,
  setProductSKU,
  selectedSKU,
  onChange,
  viewType,
}) => (
  <div className="swatches">
    {swatches && viewType === 'hand' && (
      <div className="swatches__grid">
        {swatches.map((swatch) => (
          <div
            key={swatch.uid}
            className={`swatches__swatch ${
              swatch.shape
                ? swatch.shape.map((shape) => shape.code).join(' ')
                : ''
            }`}
          >
            <button
              type="button"
              style={{
                backgroundColor: swatch.skuColor,
                border:
                  selectedSKU === swatch.sku
                    ? '1px solid #FC4C02'
                    : '1px solid transparent',
              }}
              onClick={() => {
                setProductSKU(swatch.sku);
                onChange({ shade: swatch.itemName, sku: swatch.sku });
              }}
            >
              <span className="sr-only">
                {swatch.itemName} - {swatch.sku}
              </span>
              {swatch.handImage && (
                <img src={swatch.handImage} alt={swatch.itemName} />
              )}
            </button>
          </div>
        ))}
      </div>
    )}

    {swatches && viewType === 'texture' && (
      <div className="swatches__grid">
        {swatches.map((swatch) => (
          <div
            key={swatch.uid}
            className={`swatches__swatch ${
              swatch.shape
                ? swatch.shape.map((shape) => shape.code).join(' ')
                : ''
            }`}
          >
            <button
              type="button"
              style={{
                backgroundColor: swatch.skuColor,
                border:
                  selectedSKU === swatch.sku
                    ? '1px solid #FC4C02'
                    : '1px solid transparent',
              }}
              onClick={() => {
                setProductSKU(swatch.sku);
                onChange({ shade: swatch.itemName, sku: swatch.sku });
              }}
            >
              <span className="sr-only">
                {swatch.itemName} - {swatch.sku}
              </span>
              {swatch.skuImage && (
                <img src={swatch.skuImage} alt={swatch.itemName} />
              )}
            </button>
          </div>
        ))}
      </div>
    )}
  </div>
);

ProductSwatch.propTypes = {
  swatches: PropTypes.arrayOf(
    PropTypes.shape({
      skuSize: PropTypes.string,
      sku: PropTypes.string,
      itemName: PropTypes.string,
    })
  ).isRequired,
  selectedSKU: PropTypes.string.isRequired,
  setProductSKU: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  viewType: PropTypes.string,
};

export default ProductSwatch;
